import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ErrorComponent} from './shared/error/error.component'
import {InitComponent} from './init/init.component'

const routes: Routes = [
  {path: 'error', component: ErrorComponent, pathMatch: 'full'},
  {path: '', component: InitComponent, pathMatch: 'full'},
  {
    path: 'start',
    loadChildren: () => import('./samoobsluga/strona-startowa/strona-startowa.module').then(module => module.StronaStartowaModule)
  },
  {
    path: 'procesUszkodzen',
    loadChildren: () => import('./samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/ekran-podsumowania.module').then(m => m.EkranPodsumowaniaModule)
  },
  {
    path: 'decyzja',
    loadChildren: () => import('./samoobsluga/proces-decyzji/ekran-decyzji/ekran-decyzji.module')
      .then(module => module.EkranDecyzjiModule)
  },
  {
    path: 'brakPrezentacjiKwoty',
    loadChildren: () => import('./samoobsluga/proces-decyzji/ekran-braku-prezentacji-kwoty-po-kalkulacji/ekran-braku-prezentacji-kwoty-po-kalkulacji.module')
      .then(module => module.EkranBrakuPrezentacjiKwotyPoKalkulacjiModule)
  },
  {
    path: 'przerwanieProcesu',
    loadChildren: () => import('./samoobsluga/przerwanie-procesu/wymagane-ogledziny-przyczyna/wymagane-ogledziny-przyczyna.module')
      .then(module => module.WymaganeOgledzinyPrzyczynaModule)
  },
  {
    path: 'decyzjaRoszczenie',
    loadChildren: () => import('./samoobsluga/proces-decyzji/ekran-pytanie-o-roszczenie/ekran-roszczenie.module')
      .then(module => module.EkranRoszczenieModule)
  },
  {
    path: 'wyslijLink',
    loadChildren: () => import('./samoobsluga/przerwanie-procesu/wyslij-link/wyslij-link.module')
      .then(module => module.WyslijLinkModule)
  },
  {
    path: 'dokumentyKontakt',
    loadChildren: () => import('./samoobsluga/proces-decyzji/ekran-dokumenty-kontakt/ekran-dokumenty-kontakt.module')
      .then(module => module.EkranDokumentyKontaktModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
